/* Bilingual EN/CY dictionary — SITE CHROME ONLY.
 * Long-form survivor content is intentionally NOT in here until it
 * can be reviewed by a professional Welsh translator.
 *
 * Welsh terminology chosen to match Welsh Government / Live Fear Free
 * conventions where possible. Anything the user's Welsh-speaking
 * reviewer wants to adjust should be edited here — one place.
 */

export const LANGS = [
  { code: 'en', label: 'English', native: 'English', htmlLang: 'en-GB' },
  { code: 'cy', label: 'Welsh', native: 'Cymraeg', htmlLang: 'cy' },
];

export const dict = {
  en: {
    // App identity
    'app.name': 'The Full Impact',
    'app.tagline': 'Sexual violence & domestic abuse · Read in your browser',

    // Nav (also used in mobile bottom tab bar)
    'nav.home': 'Home',
    'nav.sv': 'SV',
    'nav.sv.full': 'Sexual Violence',
    'nav.da': 'DA',
    'nav.da.full': 'Domestic Abuse',
    'nav.rights': 'Rights',
    'nav.consent': 'Consent',
    'nav.support': 'Support',
    'nav.journal': 'Journal',
    'nav.trauma': 'Trauma',

    // Chrome buttons / labels
    'btn.exit': 'Exit Now',
    'btn.exit.aria': 'Exit this site immediately',
    'btn.menu.open': 'Open menu',
    'btn.menu.close': 'Close menu',
    'btn.print': 'Print / Save this page',
    'btn.ground': 'Ground me',
    'btn.ground.aria': 'Open grounding exercises',
    'btn.close': 'Close',
    'btn.back': 'Back',
    'btn.refresh': 'Refresh',
    'btn.signout': 'Sign out',
    'btn.language.aria': 'Change language',
    'btn.accessibility': 'Accessibility',
    'btn.accessibility.aria': 'Open accessibility settings',

    // Skip-link + landmarks
    'skip.main': 'Skip to main content',
    'nav.aria.primary': 'Primary',
    'nav.aria.mobile': 'Mobile primary',
    'nav.aria.tabbar': 'Bottom tab bar',

    // Footer
    'footer.line1': 'Anonymous & free · Quick exit available on every page',
    'footer.why': 'Why I created this',
    'footer.about': 'About & Privacy',
    'footer.accessibility': 'Accessibility statement',
    'footer.faq': 'FAQ',
    'footer.stats': 'View visit stats',

    // Language toggle
    'lang.switch.to.cy': 'Cymraeg',
    'lang.switch.to.en': 'English',

    // Welsh-not-yet-translated notice
    'cy.pending.eyebrow': 'CYMRAEG',
    'cy.pending.title': 'Cymraeg — coming soon',
    'cy.pending.body':
      'The site chrome (menu, buttons, footer, accessibility statement) is available in Welsh. The long-form survivor guidance on this page is being professionally translated — we would rather wait than publish machine translation on a trauma-informed service. The English version below is available in full.',
    'cy.pending.continue': 'Continue in English',

    // Stats page login form
    'stats.login.title': 'Admin sign-in',
    'stats.login.label': 'Admin key',
    'stats.login.help': 'Enter your admin key to view anonymous visit stats.',
    'stats.login.submit': 'Sign in',
    'stats.login.error': 'That admin key is not correct. Please try again.',
  },

  cy: {
    // App identity
    'app.name': 'The Full Impact',
    'app.tagline': 'Trais rhywiol a cham-drin domestig · Darllen yn eich porwr',

    // Nav
    'nav.home': 'Hafan',
    'nav.sv': 'TR',
    'nav.sv.full': 'Trais Rhywiol',
    'nav.da': 'CD',
    'nav.da.full': 'Cam-drin Domestig',
    'nav.rights': 'Hawliau',
    'nav.consent': 'Caniatâd',
    'nav.support': 'Cymorth',
    'nav.journal': 'Dyddiadur',
    'nav.trauma': 'Trawma',

    // Chrome
    'btn.exit': 'Gadael Nawr',
    'btn.exit.aria': 'Gadael y wefan hon ar unwaith',
    'btn.menu.open': 'Agor y ddewislen',
    'btn.menu.close': 'Cau’r ddewislen',
    'btn.print': 'Argraffu / Cadw’r dudalen hon',
    'btn.ground': 'Sadio fi',
    'btn.ground.aria': 'Agor ymarferion sadio',
    'btn.close': 'Cau',
    'btn.back': 'Yn ôl',
    'btn.refresh': 'Adnewyddu',
    'btn.signout': 'Allgofnodi',
    'btn.language.aria': 'Newid iaith',
    'btn.accessibility': 'Hygyrchedd',
    'btn.accessibility.aria': 'Agor gosodiadau hygyrchedd',

    // Skip-link
    'skip.main': 'Neidio i’r prif gynnwys',
    'nav.aria.primary': 'Prif',
    'nav.aria.mobile': 'Prif ddewislen symudol',
    'nav.aria.tabbar': 'Bar tabiau ar y gwaelod',

    // Footer
    'footer.line1': 'Dienw ac am ddim · Gadael cyflym ar bob tudalen',
    'footer.why': 'Pam wnes i greu hwn',
    'footer.about': 'Amdanom a Phreifatrwydd',
    'footer.accessibility': 'Datganiad hygyrchedd',
    'footer.faq': 'Cwestiynau Cyffredin',
    'footer.stats': 'Gweld ystadegau ymweliadau',

    // Language toggle
    'lang.switch.to.cy': 'Cymraeg',
    'lang.switch.to.en': 'English',

    // Cy-pending notice
    'cy.pending.eyebrow': 'CYMRAEG',
    'cy.pending.title': 'Cymraeg — yn dod yn fuan',
    'cy.pending.body':
      'Mae elfennau’r wefan (dewislen, botymau, troedyn, datganiad hygyrchedd) ar gael yn Gymraeg. Mae’r wybodaeth fanwl i oroeswyr ar y dudalen hon yn cael ei chyfieithu’n broffesiynol — mae’n well gennym aros na chyhoeddi cyfieithiad peiriannol ar wasanaeth sy’n ystyriol o drawma. Mae’r fersiwn Saesneg isod ar gael yn llawn.',
    'cy.pending.continue': 'Parhau yn Saesneg',

    // Stats page login
    'stats.login.title': 'Mewngofnodi gweinyddwr',
    'stats.login.label': 'Allwedd gweinyddwr',
    'stats.login.help':
      'Rhowch eich allwedd gweinyddwr i weld ystadegau ymweliadau dienw.',
    'stats.login.submit': 'Mewngofnodi',
    'stats.login.error': 'Nid yw’r allwedd gweinyddwr yn gywir. Rhowch gynnig arall.',
  },
};

/* Fallback lookup helper. If a key is missing in cy, fall back to en. */
export function t(lang, key) {
  const table = dict[lang] || dict.en;
  if (table[key] !== undefined) return table[key];
  return dict.en[key] !== undefined ? dict.en[key] : key;
}
